import { StrongText, StyledFlex } from '@dreryk/react-components';

import {
   FieldScope,
   MedicalProfileTabFormController,
   SectionNodeViewModel,
   VisibilityResolver,
} from '../tab/MedicalProfileTab.types';

import { DetailSurveyFields } from './fields/DetailSurveyFields';

type SectionNodeFieldsProps = Pick<MedicalProfileTabFormController, 'register'> & {
   readonly templateCode: string;
   readonly nodes: SectionNodeViewModel[];
   readonly visibility: VisibilityResolver;
   readonly disabled: boolean;
   readonly scope?: FieldScope;
   readonly renderRepeatable?: (node: SectionNodeViewModel) => JSX.Element | null;
};

export const SectionNodeFields = (props: SectionNodeFieldsProps): JSX.Element => (
   <StyledFlex direction={'column'} gap={16}>
      {props.nodes.map((node) => {
         if (!props.visibility.isSectionVisible(node.sectionId)) {
            return null;
         }
         if (node.repeatable) {
            // TODO DREGAB-29796: repeatable sections nested inside an entry are not supported yet
            return (
               <StyledFlex key={node.sectionId} direction={'column'}>
                  {props.renderRepeatable?.(node) ?? null}
               </StyledFlex>
            );
         }
         const visibleQuestions = node.questions.filter((question) =>
            props.visibility.isQuestionVisible(question.questionId)
         );
         return (
            <StyledFlex key={node.sectionId} direction={'column'} gap={16}>
               {node.title ? <StrongText testId={`sectionNodeTitle-${node.sectionId}`}>{node.title}</StrongText> : null}
               <DetailSurveyFields
                  register={props.register}
                  templateCode={props.templateCode}
                  questions={visibleQuestions}
                  disabled={props.disabled}
                  scope={props.scope}
               />
               <SectionNodeFields {...props} nodes={node.childSections} />
            </StyledFlex>
         );
      })}
   </StyledFlex>
);
